import RedirectChecker from "./components/RedirectChecker";

const RedirectContainer = () => {
  return <RedirectChecker />;
};

export default RedirectContainer;
